<tilby-dialog-toolbar
    mat-dialog-title
    [title]="optionList && optionList.length? title: '' "
    [disabled]="checkIfDisableSave()"
    [hideConfirm]="!optionList || optionList.length == 0"
    [hideCancel]="!!data.hideCancel"
    (confirm)="onSave()"
></tilby-dialog-toolbar>

<tilby-dialog-content>
    <form autocomplete="off" [formGroup]="form">
        @if(data.searchable !== false && optionList && optionList.length) {
            <mat-form-field appearance="fill" class="tw-flex tw-pb-4">
                <mat-label>{{searchFieldLabel}}</mat-label>
                <input matInput formControlName="filterName" type="text"/>
            </mat-form-field>
        }
            
        <ng-container *ngIf="data.multiSelection ? (filteredMultiOptions | async) : (filteredOptions | async) as elements; else loading">
            @if(elements.length > 0) {
                <cdk-virtual-scroll-viewport itemSize="40" [style.height]="viewportHeight$ | async">
                    @if(data.multiSelection) {
                        <div formArrayName="options">
                            <div *cdkVirtualFor="let option of (filteredMultiOptions | async); let i = index; trackBy: trackByControl">
                                <div [formGroup]="option">
                                    <mat-checkbox formControlName="checked"
                                        [value]="option.get('id')?.value"
                                        (change)="checkboxOptionSelectionChange($event)"
                                    >{{option.get('name')?.value}}</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    } @else {
                        <mat-radio-group
                            aria-label="Select an option"
                            formControlName="optionSelected"
                        >
                            <div *cdkVirtualFor="let product of (filteredOptions | async); trackBy: trackById">
                                <mat-radio-button 
                                    [value]="product.id"
                                    [checked]="optionSelected.value === product.id"
                                    class="tw-flex"
                                >{{product.name}}</mat-radio-button>
                            </div>
                        </mat-radio-group>
                    }
                </cdk-virtual-scroll-viewport>
            } @else if(optionList && optionList.length) {
                <div class="tw-mt-2 tw-mb-8">
                    <div class="item-selector-placeholder-content">
                        <img [src]="'assets/images/items/selector-no-result.png'" alt="No results found" />
                        <div class="item-selector-placeholder-message">{{ 'APPLICATION.ITEM_SELECTOR.NOT_EMPTY' | translate }}</div>
                    </div>
                </div>
            } @else {
                <div class="tw-mt-2 tw-mb-8">
                    <div class="item-selector-placeholder-content">
                        <img [src]="'assets/images/items/no-items.png'" alt="No items available" />
                        <div class="item-selector-placeholder-message">{{ 'APPLICATION.ITEM_SELECTOR.EMPTY' | translate }}</div>
                    </div>
                </div>
            }
        </ng-container>

        <ng-template #loading>
            <div class="loading-container">
                <mat-spinner diameter="50"></mat-spinner>
            </div>
        </ng-template>
    </form>
</tilby-dialog-content>